import produce from 'immer';
import { Reducer } from 'redux';

import { ActivitiesActionTypes } from '@/store/reducers/activities/action-types';
import { ShippingAddressesActionTypes } from '@/store/reducers/shipping-addreses/action-types';

import { OrderMetricsActionTypes, OrdersActionTypes } from './action-types';
import { initialState, initialStateOrderMetric } from './constants';
import { OrderMetricsReducerState, OrdersReducerState as State } from './types';

export const ordersReducer: Reducer<State> = (state = initialState, action): State => {
  switch (action.type) {
    case OrdersActionTypes.FETCH_ORDER.SUCCESS:
      return { ...state, order: action.payload || null, tax: null };

    case OrdersActionTypes.FETCH_ORDER_ALERT_MESSAGE.SUCCESS:
      return produce(state, (newState: State) => {
        if (newState.order) newState.order.orderCard = action.payload.orderCard;
      });

    case ActivitiesActionTypes.FETCH_ACTIVITY_DETAILS_DATA.SUCCESS:
      return { ...state, order: action.payload.activityInstances.order, tax: null };

    case OrdersActionTypes.CALCULATE_TAX.SUCCESS:
      return { ...state, tax: action.payload.tax };

    case OrdersActionTypes.CALCULATE_TAX.FAIL:
      return { ...state };

    case OrdersActionTypes.CALCULATE_TAX.CLEAN_UP:
      return { ...state, tax: null };

    case ShippingAddressesActionTypes.FETCH_SHIPPING_ADDRESSES.SUCCESS:
      return { ...state, tax: null };

    case OrdersActionTypes.CREATE_DESIGN_TO_ORDER.SUCCESS:
      return { ...state, createdOrderId: action.payload };

    case OrdersActionTypes.CREATE_DESIGN_TO_ORDER.CLEAN_UP:
      return { ...state, createdOrderId: null };

    case OrdersActionTypes.FETCH_ALL_BUCKETS_FILES_BY_ID.SUCCESS:
      return { ...state, bucketFiles: action.payload };

    case OrdersActionTypes.SET_TASK_DATE.SUCCESS: {
      if (action.sagaPayload.dateTaskType === 'INSTALL') {
        return {
          ...state,
          installDate: {
            value: action.sagaPayload.value,
            hasError: false,
          },
        };
      }

      return {
        ...state,
        deliveryDate: {
          value: action.sagaPayload.value,
          hasError: false,
        },
      };
    }

    case OrdersActionTypes.SET_TASK_DATE.FAIL: {
      if (action.sagaPayload.dateTaskType === 'INSTALL') {
        return {
          ...state,
          installDate: {
            value: '',
            hasError: true,
          },
        };
      }

      return {
        ...state,
        deliveryDate: {
          value: '',
          hasError: true,
        },
      };
    }

    case OrdersActionTypes.SET_TASK_DATE.CLEAN_UP: {
      return {
        ...state,
        deliveryDate: {
          value: '',
          hasError: false,
        },
        installDate: {
          value: '',
          hasError: false,
        },
      };
    }

    default:
      return state;
  }
};

export const orderMetricsReducer: Reducer<OrderMetricsReducerState> = (
  state = initialStateOrderMetric,
  action,
): OrderMetricsReducerState => {
  if (action.type === OrderMetricsActionTypes.FETCH_ORDER_METRIC.SUCCESS) {
    return produce(state, (newState: OrderMetricsReducerState) => {
      const { count } = action.payload;

      newState.count = count;
    });
  }

  return state;
};
